import { render, staticRenderFns } from "./popover-preview.vue?vue&type=template&id=3b7155b8"
import script from "./popover-preview.vue?vue&type=script&lang=js"
export * from "./popover-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7155b8')) {
      api.createRecord('3b7155b8', component.options)
    } else {
      api.reload('3b7155b8', component.options)
    }
    module.hot.accept("./popover-preview.vue?vue&type=template&id=3b7155b8", function () {
      api.rerender('3b7155b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Campaign/TabPrize/components/NotVeryCompatible/popover-preview.vue"
export default component.exports